/**
 * secondsFilter
 *
 * @author Dec Norton <decnorton@gmail.com>
 */

import { secondsToReadable } from '@shared/utils/datetime';

export function secondsFilter() {
    return value => {
        return secondsToReadable(value);
    };
}
